import { render, staticRenderFns } from "./statistics-recruitment-consequences.vue?vue&type=template&id=504b6b55"
import script from "./statistics-recruitment-consequences.vue?vue&type=script&lang=js"
export * from "./statistics-recruitment-consequences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports